<template>
  <div>
    <custom-dialog
      :openDialog="isOpen"
      :widthDialog="'800px'"
      :classDialog="'createDialog'"
      :offsetTop="''"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('closed')"
    >
      <template #body>
        <h3 class="dialogTitle">Yêu cầu hỗ trợ</h3>
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-position="left"
          label-width="150px"
          inline-message
          class="form-account width__100 margin-top-10"
        >
          <el-row :gutter="24" v-if="!!id">
            <el-col :span="24">
              <el-form-item label="Người yêu cầu">
                <el-input
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                  readonly
                  v-model="requestor"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Lĩnh vực sửa chữa" prop="requestTypeName">
                <el-select
                  clearable
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                  v-model="form.requestTypeName"
                  placeholder="Gõ tên để bắt đầu tìm kiếm"
                  filterable
                  @change="requestTypeNameChanged"
                >
                  <el-option
                    v-for="item in requestTypeNames"
                    :key="item.id"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Tên yêu cầu: " prop="title">
                <el-input
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                  v-model="form.title"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="Thời gian sửa chữa: " prop="processTime">
                <el-date-picker
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                  size="medium"
                  v-model="form.processTime"
                  type="datetime"
                  :prefix-icon="'none'"
                  format="dd/MM/yyyy HH:mm"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Địa điểm sửa chữa: " prop="location">
                <el-input
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                  v-model="form.location"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="Nội dung sửa chữa: " prop="note">
                <el-input
                  class="style-fullWidth input-border__bottom input-border__radius__0"
                  type="textarea"
                  :rows="3"
                  v-model="form.note"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>

      <template #footer>
        <div class="flex-row flex__left form-button__action margin-top-10">
          <el-button
            type="success"
            size="mini"
            class="addDocs btn-none__border  color__white bg__blue"
            @click="save"
          >
            <span class="flex-row flex__center">
              <i class="fas fa-save font-size__medium"></i>
              &nbsp;&nbsp;Lưu
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="addDocs btn-none__border  color__white bg__green"
            v-if="id && mode === 'approveMode' && status === 'waitForApproving'"
            @click="approve"
          >
            <span class="flex-row flex__center">
              <i class="fas fa-check font-size__medium"></i>
              &nbsp;&nbsp;Duyệt
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="addDocs btn-none__border  color__white bg__red"
            v-if="id"
            @click="delete_"
          >
            <span class="flex-row flex__center">
              <i class="fas fa-trash font-size__medium"></i>
              &nbsp;&nbsp;Xóa
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            @click="cancel"
          >
            <span class="flex-row flex__center">
              <i class="far fa-times-circle font-size__medium"></i>
              &nbsp;&nbsp;Hủy
            </span>
          </el-button>
        </div>
      </template>
    </custom-dialog>
  </div>
</template>

<script>
  import CustomDialog from "../../common/custom-dialog";
  import hoTroYeuCauService from "../../../services/hoTroYeuCauService";

  export default {
    name: "hotroyeucau-create-dialog",
    props: ["isOpen", "id", "mode"],
    components: {CustomDialog},
    data() {
      return {
        requestor: null,
        selectedItem: null,
        form: {
          requestTypeName: null,
          title: null,
          processTime: null,
          note: null,
          location: null
        },
        requestTypeNames: [],
        rules: {
          requestTypeName: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ],
          title: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ],
          processTime: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ],
          location: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ]
        }
      };
    },

    computed: {
      status() {
        return this.selectedItem ? this.selectedItem.status : null;
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      }
    },

    created() {
      this.initPage();
      if (this.id) this.initFormForEdit();
    },

    methods: {
      initFormForEdit() {
        hoTroYeuCauService.findById(this.id).then(response => {
          let item = (this.selectedItem = response.data);
          this.form.requestTypeName = item.requestTypeName;
          this.form.title = item.title;
          this.form.processTime = new Date(item.processTime);
          this.form.note = item.note;
          this.form.location = item.location;
          this.requestor = item.requestor;
        });
      },

      initPage() {
        this.requestTypeNames = [
          "An ninh tòa nhà",
          "Cây xanh",
          "Vệ sinh nơi làm việc"
        ];
      },

      requestTypeNameChanged(event) {
      },

      convertToSubmitForm() {
        return {
          requestTypeName: this.form.requestTypeName,
          title: this.form.title,
          processTime: this.form.processTime.getTime(),
          note: this.form.note,
          location: this.form.location
        };
      },

      save() {
        this.$refs.form.validate(valid => {
          if (valid) {
            let submitForm = this.convertToSubmitForm();
            (!this.id
                ? hoTroYeuCauService.insert(submitForm, this.userDeptRole)
                : hoTroYeuCauService.update(this.id, submitForm)
            ).then(() => {
              this.notify(
                "Thông báo",
                !this.id
                  ? "Tạo mới yêu cầu thành công"
                  : "Cập nhật yêu cầu thành công",
                "success",
                2000
              );
              this.$emit("success");
            });
          }
        });
      },

      approve() {
        this.$refs.form.validate(valid => {
          if (valid) {
            let submitForm = this.convertToSubmitForm();
            hoTroYeuCauService
              .update(this.id, submitForm)
              .then(() => hoTroYeuCauService.approve(this.id))
              .then(() => {
                this.notify(
                  "Thông báo",
                  "Phê duyệt yêu cầu thành công",
                  "success",
                  2000
                );
                this.$emit("success");
              });
          }
        });
      },

      delete_() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.$confirm("Bạn có muốn hủy yêu cầu này?", "Thông báo", {
              confirmButtonText: "Xác nhận",
              cancelButtonText: "Bỏ qua",
              type: "warning"
            }).then(() => {
              return hoTroYeuCauService.delete(this.id).then(() => {
                this.notify(
                  "Thông báo",
                  "Hủy yêu cầu thành công",
                  "success",
                  2000
                );
                this.$emit("success");
              });
            });
          }
        });
      },

      cancel() {
        this.$emit("closeDialog");
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/hotroyeucau/hotroyeucau-create-dialog.vue